import { render, staticRenderFns } from "./orderTalk.vue?vue&type=template&id=ba75fc3a&scoped=true&"
import script from "./orderTalk.vue?vue&type=script&lang=js&"
export * from "./orderTalk.vue?vue&type=script&lang=js&"
import style0 from "./orderTalk.vue?vue&type=style&index=0&id=ba75fc3a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba75fc3a",
  null
  
)

export default component.exports